const initProfileForm = () => {
  const childrenWrapperEl = document.querySelector('.js_children_wrapper')
  const hasChildrenRadioEls = document.querySelectorAll('.js_profile_form_children_radio_button')
  const addMoreChildrenButtonEl = document.querySelector('.js_profile_form__add_more_children_button')

  const animalsWrapperEl = document.querySelector('.js_animals_wrapper')
  const hasAnimalsRadioEls = document.querySelectorAll('.js_profile_form_animals_radio_button')
  const addMoreAnimalsButtonEl = document.querySelector('.js_profile_form__add_more_animals_button')

  hasChildrenRadioEls.forEach(el => {
    el.addEventListener('change', e => toggleInputEls(e.target.value, 'children'))
  })

  hasAnimalsRadioEls.forEach(el => {
    el.addEventListener('change', e => toggleInputEls(e.target.value, 'animals'))
  })

  if (addMoreAnimalsButtonEl) {
    addMoreAnimalsButtonEl.addEventListener('click', () => {
      const newAnimalsContainerEl = buildNewAnimalsContainerEl()
      animalsWrapperEl.appendChild(newAnimalsContainerEl)
    })
  }

  if (addMoreChildrenButtonEl) {
    addMoreChildrenButtonEl.addEventListener('click', () => {
      const newChildrenContainerEl = buildNewChildrenContainerEl()
      childrenWrapperEl.appendChild(newChildrenContainerEl)
    })
  }
}

const toggleInputEls = (shouldDisplay, lifestyleAttr) => {
  const addMoreButtonEl = document.querySelector(`.js_profile_form__add_more_${lifestyleAttr}_button`)
  const inputContainerEls = document.querySelectorAll(`.js_${lifestyleAttr}_container`)
  const hiddenValue = shouldDisplay !== 'true'

  addMoreButtonEl.hidden = hiddenValue
  inputContainerEls.forEach(el => el.hidden = hiddenValue)
}

const buildNewAnimalsContainerEl = () => {
  const animalsContainersCount = document.querySelectorAll('.js_animals_container').length
  const firstAnimalsContainerEl = document.querySelector('.js_animals_container')
  const newEl = firstAnimalsContainerEl.cloneNode(true)

  newEl.children.forEach(childEl => {
    const lifestyleAnimalsAttrName = childEl.dataset.attrName

    childEl.children.forEach(el => {
      if (el.tagName === 'LABEL') {
        overrideHtmlAttribute(
          el, "for",
          `profile_form_animals_${animalsContainersCount + 1}_${lifestyleAnimalsAttrName}`
        )
      }
      if (el.tagName === 'SELECT') {
        overrideHtmlAttribute(
          el, "name",
          `profile_form[animals][${animalsContainersCount + 1}][${lifestyleAnimalsAttrName}]`
        )
        overrideHtmlAttribute(
          el, "id",
          `profile_form_animals_${animalsContainersCount + 1}_${lifestyleAnimalsAttrName}`
        )
        el.value = ""
      }
      if (el.tagName === 'INPUT') {
        overrideHtmlAttribute(
          el, "name",
          `profile_form[animals][${animalsContainersCount + 1}][${lifestyleAnimalsAttrName}]`
        )
        overrideHtmlAttribute(
          el, "id",
          `profile_form_animals_${animalsContainersCount + 1}_${lifestyleAnimalsAttrName}`
        )
        el.value = ""
      }
    })
  })

  return newEl
}

const buildNewChildrenContainerEl = () => {
  const childrenContainersCount = document.querySelectorAll('.js_children_container').length
  const firstChildrenContainerEl = document.querySelector('.js_children_container')
  const newEl = firstChildrenContainerEl.cloneNode(true)

  newEl.children.forEach(childEl => {
    const lifestyleChildrenAttrName = childEl.dataset.attrName

    childEl.children.forEach(el => {
      if (el.tagName === 'LABEL') {
        overrideHtmlAttribute(
          el, "for",
          `profile_form_children_${childrenContainersCount + 1}_${lifestyleChildrenAttrName}`
        )
      }
      if (el.tagName === 'SELECT') {
        overrideHtmlAttribute(
          el, "name",
          `profile_form[children][${childrenContainersCount + 1}][${lifestyleChildrenAttrName}]`
        )
        overrideHtmlAttribute(
          el, "id",
          `profile_form_children_${childrenContainersCount + 1}_${lifestyleChildrenAttrName}`
        )
        el.value = ""
      }
    })
  })

  return newEl
}

const overrideHtmlAttribute = (element, attributeName, attributeValues) => {
  element.removeAttribute(attributeName)
  element.setAttribute(attributeName, attributeValues)
}

export default () => {
  const profileFormEl = document.querySelector('.js_profile_form')

  if (profileFormEl) initProfileForm()
}
